import { filterDiffFunction } from './chunk-WTGT4IDV.mjs';

// src/helpers/factories/settingsDifferences/diffLicenseSettingsFactory.ts
var LicenseSettings = /* @__PURE__ */ ((LicenseSettings2) => {
  LicenseSettings2[LicenseSettings2["nickname"] = 0] = "nickname";
  LicenseSettings2[LicenseSettings2["revenueCenterId"] = 1] = "revenueCenterId";
  LicenseSettings2[LicenseSettings2["registerAutoLock"] = 2] = "registerAutoLock";
  LicenseSettings2[LicenseSettings2["language"] = 3] = "language";
  LicenseSettings2[LicenseSettings2["fontSize"] = 4] = "fontSize";
  LicenseSettings2[LicenseSettings2["overrideRestaurantMode"] = 5] = "overrideRestaurantMode";
  LicenseSettings2[LicenseSettings2["displayMode"] = 6] = "displayMode";
  LicenseSettings2[LicenseSettings2["overrideDefaultMenuTypeId"] = 7] = "overrideDefaultMenuTypeId";
  LicenseSettings2[LicenseSettings2["suppressSuggestiveOrdering"] = 8] = "suppressSuggestiveOrdering";
  LicenseSettings2[LicenseSettings2["printOrderNumberOnSend"] = 9] = "printOrderNumberOnSend";
  LicenseSettings2[LicenseSettings2["defaultServiceAreaId"] = 10] = "defaultServiceAreaId";
  LicenseSettings2[LicenseSettings2["defaultServiceAreaOption"] = 11] = "defaultServiceAreaOption";
  LicenseSettings2[LicenseSettings2["suppressSeating"] = 12] = "suppressSeating";
  LicenseSettings2[LicenseSettings2["qsrSendAndPayActionButtonsOverride"] = 13] = "qsrSendAndPayActionButtonsOverride";
  LicenseSettings2[LicenseSettings2["sendOrderToKitchenOverride"] = 14] = "sendOrderToKitchenOverride";
  LicenseSettings2[LicenseSettings2["autoPrintChit"] = 15] = "autoPrintChit";
  return LicenseSettings2;
})(LicenseSettings || {});
var returnLabel = (field) => {
  if (field in LicenseSettings) {
    return field;
  }
};
var diffLicenseSettingsFactory = (diffArray) => {
  if (diffArray.length > 0) {
    const licenseSettings = generateLicenseSettingsObj(diffArray);
    return licenseSettings;
  }
  return null;
};
var generateLicenseSettingsObj = (diffArray) => {
  let licenseSettings = {};
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ field, diffLength }) => {
        if (diffLength !== 1) {
          return;
        }
        if (diff.kind === "E") {
          const customNewDiff = {
            field,
            label: returnLabel(field) || "",
            value: diff.rhs
          };
          if (!licenseSettings.changes) {
            licenseSettings = {
              changes: [customNewDiff]
            };
          } else {
            licenseSettings.changes = [
              ...licenseSettings.changes,
              customNewDiff
            ];
          }
        }
      },
      returnLabel
    )
  );
  return licenseSettings;
};

export { diffLicenseSettingsFactory };
